import { Injectable } from '@angular/core';
import { EnrollmentHelper } from '@rd/helpers/enrollment.helper';
import { Enrollment } from '@rd/types/enrollment.type';

@Injectable({
  providedIn: 'root',
})
export class VmaEnrollmentHelper extends EnrollmentHelper {
  productTypeFromProductCode(enrollment: Enrollment): string {
    if (!!enrollment?.groupName) {
      return enrollment?.groupName;
    }

    switch (enrollment?.productCode) {
      case 'VMA.TRANSAC.ACCOUNT':
        return 'Go Account';
      case 'VMA.BONUS.SAVER':
        return 'Grow Account';
      case 'VMA.BUNDLE.SAVER':
        return 'Boost Saver';
    }

    return 'VMA card';
  }

  isHomeLoan(enrollment: Enrollment): boolean {
    return (
      enrollment?.productCode === 'VMA.FULL.FEATURE.LOAN' ||
      enrollment?.productCode === 'VMA.BASIC.HOMELOAN'
    );
  }

  isBasicHomeLoanOnly(enrollment: Enrollment): boolean {
    return enrollment?.productCode === 'VMA.BASIC.HOMELOAN';
  }

  hasOnlyBasicHomeLoanEnrollments(enrollments: Enrollment[]): boolean {
    return (
      !!enrollments.length &&
      enrollments.filter(this.isBasicHomeLoanOnly).length === enrollments.length
    );
  }
}
